export default __webpack_public_path__ + "static/media/cloud_folder.570d6351.svg";